import styles from "./RadioCard.module.css";

type RadioCardProps = {
  value: string | null;
  label: string;
  description?: string;
  checked: boolean;
  onChange: (value: string | null) => void;
  name: string;
  disabled?: boolean;
  compact?: boolean;
};

export function RadioCard({
  value,
  label,
  description,
  checked,
  onChange,
  name,
  disabled = false,
  compact = false,
}: RadioCardProps) {
  function handleChange() {
    if (!disabled) {
      onChange(value);
    }
  }

  function handleKeyDown(event: React.KeyboardEvent) {
    if (disabled) return;

    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onChange(value);
    }
  }

  const cardClassName = [
    styles.radioCard,
    checked ? styles.checked : "",
    disabled ? styles.disabled : "",
    compact ? styles.compact : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <label className={cardClassName} onKeyDown={handleKeyDown}>
      <input
        type="radio"
        name={name}
        value={value ?? ""}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className={styles.radioInput}
      />
      <div className={styles.content}>
        <div className={styles.label}>{label}</div>
        {description && <div className={styles.description}>{description}</div>}
      </div>
      <div className={styles.indicator}>
        {checked && <span className={styles.checkmark}>✓</span>}
      </div>
    </label>
  );
}
